import type { TAddress } from '@verifime/utils';

export type { TAddress };

export type AddressFieldKey =
  | 'unitNumber'
  | 'streetNumber'
  | 'streetName'
  | 'streetType'
  | 'suburb'
  | 'city'
  | 'state'
  | 'postcode';

export type AddressFieldConfig = {
  key: AddressFieldKey;
  label: string;
  required?: boolean;
};

export const DEFAULT_ADDRESS_FIELDS: AddressFieldConfig[] = [
  { key: 'unitNumber', label: 'Unit Number' },
  { key: 'streetNumber', label: 'Street Number', required: true },
  { key: 'streetName', label: 'Street Name', required: true },
  { key: 'streetType', label: 'Street Type' },
  { key: 'suburb', label: 'Suburb' },
  { key: 'postcode', label: 'Postcode', required: true },
];

export type Suggestion = {
  label: string;
  placeId: string;
};

export type AddressAutocompleteProps = {
  value: Partial<TAddress>;
  onChange: (value: Partial<TAddress>) => void;
  suggestions: Suggestion[];
  isLoading: boolean;
  hasQueried?: boolean;
  errorHint?: string;
  onQueryChange: (query: string) => void;
  onSuggestionSelect: (placeId: string) => void;
  query?: string;
  fields?: AddressFieldConfig[];
  title?: string;
  placeholder?: string;
  startInAutoComplete?: boolean;
};
